import { incidentR } from "./Components/data";

export const IR = {
  sunny: {
    value: 1.0,
    label: "Sunny",
  },
  cloudy: {
    value: 0.5,
    label: "Cloudy",
  },
};

export const materialAlbedo = {
  Direct: {
    "Red bricks": 0.31,
    "Buff lime bricks": 0.42,
    "Magnolia bricks": 0.65,
    "White bricks": 0.73,
    "Concrete paving": 0.27,
    Tarmac: 0.12,
    "Roof tiles": 0.21,
    Glass: 0.06,
    Wood: 0.43,
    "Aluminium cladding": 0.22,
  },
  Diffuse: {
    "Red bricks": 0.31,
    "Buff lime bricks": 0.42,
    "Magnolia bricks": 0.65,
    "White bricks": 0.63,
    "Concrete paving": 0.27,
    Tarmac: 0.12,
    "Roof tiles": 0.21,
    Glass: 0.11,
    Wood: 0.44,
    "Aluminium cladding": 0.22,
  },
};

export const times = [
  "Mean",
  "0330",
  "0430",
  "0530",
  "0630",
  "0730",
  "0830",
  "0930",
  "1030",
  "1130",
  "1230",
  "1330",
  "1430",
  "1530",
  "1630",
  "1730",
  "1830",
  "1930",
  "2030",
];

export const directions = ["N", "NE", "E", "SE", "S", "SW", "W", "NW"];

export const dates = Object.getOwnPropertyNames(incidentR);
